import React, { useContext, useState } from "react";
import { CartContext } from "./CartContext";
import "../css/checkout.css";
import productData from "../Datas/productData";
import { Link } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";

const SHIPPING_FEE = 9.99;
const RESTRICTED_COUNTRIES = ["BY", "CU", "IR", "KP", "RU", "SY"];

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [address1, setAddress1] = useState("");
  const [contact, setContact] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [company, setCompany] = useState("");
  const [errors, setErrors] = useState({});

  const getProductById = (id) => productData.find((product) => product.id === id);
  const lines = cartItems.map((item) => ({ item, product: getProductById(item.id) })).filter(({ product }) => Boolean(product));
  const subtotal = lines.reduce((total, { item, product }) => total + Number(product.price) * item.quantity, 0);
  const total = subtotal + SHIPPING_FEE;

  const createOrderNumber = () => {
    const randomPart = window.crypto?.getRandomValues
      ? Array.from(window.crypto.getRandomValues(new Uint32Array(2))).map((number) => number.toString().padStart(10, "0")).join("")
      : Math.random().toString().slice(2).padEnd(20, "0");
    return `${Date.now()}${randomPart}`.slice(0, 30);
  };

  const handlePlaceOrder = () => {
    const nextErrors = {};
    if (!contact || !/^\S+@\S+\.\S+$/.test(contact)) nextErrors.contact = "Enter a valid email address";
    if (!countryCode) nextErrors.countryCode = "Select a delivery country";
    if (!firstName.trim()) nextErrors.firstName = "Enter a first name";
    if (!lastName.trim()) nextErrors.lastName = "Enter a last name";
    if (!address.trim()) nextErrors.address = "Enter an address";
    if (!city.trim()) nextErrors.city = "Enter a city";
    if (!postalCode.trim()) nextErrors.postalCode = "Enter a ZIP / postal code";
    if (!lines.length) nextErrors.cart = "Your cart is empty";
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;

    const origin = window.location.origin;
    const params = new URLSearchParams({
      orderNo: createOrderNumber(), amount: total.toFixed(2), currency: "USD", email: contact.trim(),
      success_url: `${origin}/payment?state=success`, cancel_url: `${origin}/payment?state=cancel`, title: lines[0].product.name,
    });
    window.location.assign(`${origin}/create_payment.php?${params.toString()}`);
  };

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main id="MainContent" className="main-containerCheck"><div className="check-custom-checkout-page">
      <div className="left"><div className="check-order-info">
        <form onSubmit={(event) => event.preventDefault()}>
          <div className="form-group"><label htmlFor="contact">Contact</label><input type="email" id="contact" name="contact" value={contact} placeholder="Email address" onChange={(e) => setContact(e.target.value)} required />{errors.contact && <p className="error">{errors.contact}</p>}</div>
          <div className="form-group"><label>Delivery</label><ReactFlagsSelect selected={countryCode} onSelect={setCountryCode} countries={RESTRICTED_COUNTRIES} blacklistCountries searchable className="check-select" />{errors.countryCode && <p className="error">{errors.countryCode}</p>}</div>
          <div className="form-row"><div className="form-group"><input type="text" name="firstName" value={firstName} placeholder="First name *" onChange={(e) => setFirstName(e.target.value)} required />{errors.firstName && <p className="error">{errors.firstName}</p>}</div><div className="form-group"><input type="text" name="lastName" value={lastName} placeholder="Last name *" onChange={(e) => setLastName(e.target.value)} required />{errors.lastName && <p className="error">{errors.lastName}</p>}</div></div>
          <div className="form-group"><input type="text" name="company-name" value={company} onChange={(e) => setCompany(e.target.value)} placeholder="Company name (optional)" /></div>
          <div className="form-group"><input type="text" name="address" value={address} onChange={(e) => setAddress(e.target.value)} required placeholder="Address" />{errors.address && <p className="error">{errors.address}</p>}</div>
          <div className="form-group"><input type="text" name="address1" value={address1} onChange={(e) => setAddress1(e.target.value)} placeholder="Apartment, suite, etc. (optional)" /></div>
          <div className="form-row"><div className="form-group"><input type="text" name="city" value={city} placeholder="City" onChange={(e) => setCity(e.target.value)} required />{errors.city && <p className="error">{errors.city}</p>}</div><div className="form-group"><input type="text" name="postalCode" value={postalCode} placeholder="Postal code" onChange={(e) => setPostalCode(e.target.value)} required />{errors.postalCode && <p className="error">{errors.postalCode}</p>}</div></div>
        <div className="form-group"><label>Shipping method</label><div className="payment-box"><div className="payment-header"><span>Standard delivery</span><strong>${SHIPPING_FEE.toFixed(2)}</strong></div></div></div>
          <div className="form-group"><label>Payment</label><div className="payment-box"><div className="payment-header"><span>Secure payment</span></div><div className="payment-body"><p>You will continue to our secure payment page after reviewing your details.</p></div></div></div>
        </form>
        {errors.cart && <p className="error">{errors.cart}</p>}<button className="check-checkout-button" onClick={handlePlaceOrder}>Pay Now</button>
        <p><Link to="/returns" style={{ textDecoration: "underline" }} onClick={toTop}>Shipping &amp; Returns Info</Link></p>
      </div></div>
      <div className="right"><div className="check-order-summary"><div className="check-order-details">
        {lines.map(({ item, product }) => <div key={`${item.id}-${item.size}-${item.color}`} className="check-cart-item"><img src={product.images[0]} alt={product.name} /><div className="pro--qty"><div className="qty-inner">{item.quantity}</div></div><div className="check-item-details"><h3>{product.name}{item.size && <><br />规格: {item.size}</>}{item.color && <><br />颜色: {item.color}</>}</h3></div><p className="cal-single">${(Number(product.price) * item.quantity).toFixed(2)}</p></div>)}
        <div className="check-summary-details">
          <div className="check-summary-row"><span>Subtotal</span><strong>${subtotal.toFixed(2)}</strong></div>
          <div className="check-summary-row"><span>Shipping</span><strong>${SHIPPING_FEE.toFixed(2)}</strong></div>
          <div className="check-summary-row check-summary-row--total"><span>Total</span><strong><small>USD</small> ${total.toFixed(2)}</strong></div>
        </div>
      </div></div></div>
    </div></main>
  );
};

export default CheckOut;
